export default __webpack_public_path__ + "static/media/tiepanel-logo.8850306d.png";